import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

function McqResultCard({
  data,
  isCorrect,
  label,
  isDescriptive,
  value,
  teacherComment,
}) {
  const [responseAttach, setResponseAttach] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);

  if (!data) return null;

  const question = data?.question;
  const userAnswer = data?.answer;
  const userAnswerKey = data?.answer?.key;
  const correctAnswerKey = question?.correct_answers[0]?.option_key;

  const getExtension = (file) => file?.split(".").pop()?.toLowerCase();

  const isImage = (file) => ["jpg", "jpeg", "png"].includes(getExtension(file));

  const isVideo = (file) => ["mp4", "mov"].includes(getExtension(file));

  const isPdf = (file) => getExtension(file) === "pdf";

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (fileUrl) => {
    setTimeout(() => {
      setResponseAttach(fileUrl);
      setMideaviewer(true);
    }, 100);
  };

  const renderAttachment = (attachment, isOption = false) => {
    const ext = getExtension(attachment);
    const fullUrl = attachment.startsWith("http")
      ? attachment
      : `${IP}${attachment}`;

    const fileIcon =
      iconData?.find((i) => i.extension === ext)?.icon ||
      "/images/file_icon.png";

    if (isImage(attachment)) {
      return isOption ? (
        <ZoomableImage src={attachment} />
      ) : (
        <img
          src={IP + attachment}
          alt="Attachment"
          style={{
            maxWidth: "200px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            cursor: "pointer",
          }}
          onClick={() => handleClick(attachment)}
        />
      );
    } else if (isVideo(attachment)) {
      return (
        <video
          src={fullUrl}
          style={{
            width: isOption ? "60px" : "200px",
            height: isOption ? "50px" : "150px",
            borderRadius: "6px",
            marginBottom: "5px",
          }}
          controls
        />
      );
    } else if (isPdf(attachment)) {
      console.log(isPdf(attachment), "ispdf?");
      return (
        <div
          onClick={() => handleClickforpdf(attachment)}
          style={{
            width: isOption ? "100px" : "200px",
            height: isOption ? "50px" : "60px",
            background: "#f5f5f5",
            borderRadius: "6px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "6px 0px",
            gap: "8px",
            padding: "0 10px",
          }}
        >
          <img
            src={fileIcon}
            alt="pdf"
            style={{ width: "24px", height: "24px" }}
          />
          <div
            style={{
              fontSize: "12px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "120px",
            }}
          >
            {attachment.replace(/^[^_]*_/, "")}
          </div>
        </div>
      );
    } else {
      // Other files - use Google Docs viewer or download
      return (
        <a
          href={`https://docs.google.com/gview?url=${encodeURIComponent(
            fullUrl,
          )}&embedded=true`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              width: isOption ? "100px" : "200px",
              height: isOption ? "50px" : "60px",
              background: "#f5f5f5",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "0 10px",
            }}
          >
            <img
              src={fileIcon}
              alt="file"
              style={{ width: "24px", height: "24px" }}
            />
            <div
              style={{
                fontSize: "12px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "120px",
              }}
            >
              {attachment.replace(/^[^_]*_/, "")}
            </div>
          </div>
        </a>
      );
    }
  };

  const renderOptionAttachment = (option) => {
    if (!option.attachment) return null;

    const fileUrl =
      typeof option.attachment === "string"
        ? option.attachment
        : option.attachment?.url;

    if (!fileUrl) return null;

    return <Box sx={{ mt: 1, ml: 4 }}>{renderAttachment(fileUrl, true)}</Box>;
  };

  return (
    <>
      <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, mb: 3 }}>
        <Typography
          variant="h6"
          className="flex justify-between items-center"
          gutterBottom
        >
          <div>
            {label}. {question.title}
          </div>
          <div>
            (
            {!isDescriptive ? (
              <span>
                <span>Marks - </span>
                <span
                  style={{
                    fontWeight: "bold",
                    color: isCorrect === "correct" ? "green" : "red",
                  }}
                >
                  {isCorrect === "correct" ? question.correct_score : 0}
                </span>
                /
                <span style={{ fontWeight: "bold", color: "black" }}>
                  {question.correct_score}
                </span>
              </span>
            ) : (
              <span className="text-center">
                <span className="">Marks - </span>
                <span
                  style={{
                    color:
                      value === 0
                        ? "red"
                        : value === question.correct_score
                          ? "green"
                          : "orange",
                    fontWeight: "bold",
                  }}
                >
                  {value}
                </span>
                /
                <span style={{ color: "green", fontWeight: "bold" }}>
                  {question.correct_score}
                </span>
              </span>
            )}
            )
          </div>
        </Typography>

        {/* Question Attachments */}
        {question?.attachments?.length > 0 && (
          <Box
            sx={{
              my: 2,
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {question?.attachments.map((att, idx) => (
              <div key={idx}>{renderAttachment(att)}</div>
            ))}
          </Box>
        )}

        {/* Options */}
        {isDescriptive ? (
          <Box sx={{ mt: 2 }}>
            {/* Your Answer */}
            <Box
              sx={{
                p: 2,
                mb: 2,
                borderRadius: 2,
                bgcolor: "#fafafa",
                border: "2px solid",
                borderColor:
                  value === 0
                    ? "red"
                    : value === question.correct_score
                      ? "green"
                      : "orange",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                  color:
                    value === 0
                      ? "red"
                      : value === question.correct_score
                        ? "green"
                        : "orange",
                }}
              >
                Your Answer:
              </Typography>

              <Typography sx={{ mb: 1 }}>
                {data.description ||
                  data.answer?.explanation ||
                  "No answer provided"}
              </Typography>

              {/* If user uploaded attachments */}
              {data?.attachments?.length > 0 && (
                <Box sx={{ mt: 1, display: "flex", gap: 2, flexWrap: "wrap" }}>
                  {data.attachments.map((att, idx) => (
                    <div key={idx}>{renderAttachment(att)}</div>
                  ))}
                </Box>
              )}
            </Box>

            {teacherComment && (
              <Box
                sx={{
                  mt: 1,
                  mb: 1,
                  p: 1.5,
                  borderRadius: 1,
                  bgcolor: "#fffbe6",
                  border: "1px dashed #f0ad4e",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontStyle: "italic",
                    color: "#8a6d3b",
                  }}
                >
                  Teacher's Comment
                </Typography>
                <Typography sx={{ color: "#5a4632" }}>
                  {teacherComment}
                </Typography>
              </Box>
            )}

            {/* Correct Answer */}
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#e8f5e9",
                border: "1px solid #81c784",
              }}
            >
              <Typography sx={{ fontWeight: "bold", mb: 1, color: "#2e7d32" }}>
                Expected Answer:
              </Typography>
              <Typography sx={{ mb: 1 }}>
                {question.correct_answers[0]?.reason_for_answer?.explanation ||
                  "No correct answer explanation"}
              </Typography>

              {/* Correct Answer attachment */}
              {question.correct_answers[0]?.reason_for_answer?.attachment && (
                <Box sx={{ mt: 1 }}>
                  {renderAttachment(
                    question.correct_answers[0].reason_for_answer.attachment,
                  )}
                </Box>
              )}
            </Box>
          </Box>
        ) : (
          /* MCQ UI */
          <>
            {question.options.map((opt) => {
              const isCorrectOpt = opt.key === correctAnswerKey;
              const isUser = opt.key === userAnswerKey;

              return (
                <Box key={opt.key}>
                  <Box
                    sx={{
                      p: 1.5,
                      borderRadius: 1,
                      display: "flex",
                      alignItems: "center",
                      mb: 1,
                      bgcolor: isCorrectOpt
                        ? "#e6f4ea"
                        : isUser
                          ? "#fdecea"
                          : "#fff",
                      border: isCorrectOpt
                        ? "1px solid #4caf50"
                        : isUser
                          ? "1px solid #f44336"
                          : "1px solid #ddd",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                      {opt.key}.
                    </Typography>
                    <Typography sx={{ flexGrow: 1 }}>{opt.value}</Typography>

                    {isCorrectOpt && (
                      <Typography sx={{ color: "#4caf50", fontWeight: "bold" }}>
                        Correct Answer
                      </Typography>
                    )}
                    {isUser && !isCorrectOpt && (
                      <Typography sx={{ color: "#f44336", fontWeight: "bold" }}>
                        Your Answer
                      </Typography>
                    )}
                  </Box>

                  {/* Option Attachments */}
                  {renderOptionAttachment(opt)}
                </Box>
              );
            })}

            {/* Result */}
            <Typography
              sx={{
                mt: 2,
                color: isCorrect ? "green" : "red",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
              }}
            >
              {userAnswer?.key === " " ? (
                <div className="d-flex align-items-center">
                  <img
                    src="/HwImg/WrongAnswerIcon.png"
                    alt=""
                    className="ml-2"
                  />
                  <div className="m-1 wrong">Student Not Answered</div>
                </div>
              ) : userAnswer?.key ===
                question?.correct_answers[0]?.option_key ? (
                <div className="mt-3">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center">
                      <img src="/HwImg/CoorectAnswerIcon.png" alt="" />
                    </div>
                    <div className="Corect" style={{ color: "#45BF55" }}>
                      Correct
                    </div>
                  </div>
                </div>
              ) : (
                <div className="mt-3">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center">
                      <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                    </div>
                    <div className="wrong">Wrong</div>
                  </div>
                </div>
              )}
            </Typography>

            {/* Explanation */}
            <Typography sx={{ mt: 1, color: "gray" }}>
              {question.correct_answers[0]?.reason_for_answer?.explanation ||
                data.answer?.explanation}
            </Typography>

            {teacherComment && (
              <Box
                sx={{
                  mt: 1,
                  mb: 1,
                  p: 1.5,
                  borderRadius: 1,
                  bgcolor: "#fffbe6",
                  border: "1px dashed #f0ad4e",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontStyle: "italic",
                    color: "#8a6d3b",
                  }}
                >
                  Teacher's Comment
                </Typography>
                <Typography sx={{ color: "#5a4632" }}>
                  {teacherComment}
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>

      {/* PDF Viewer Modal */}
      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {/* Image/Video Full Size Viewer */}
      {isClicked &&
        (responseAttach.split(".").pop()?.toLowerCase() === "mp4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={() => handleClick()}
                  src="/DCM-img/crossIcon.svg"
                  alt="Close"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={() => {
                        handleClick();
                        setIsError(false);
                      }}
                      src="/images/cross.png"
                      alt="Close"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => handleClick()}
                    src="/images/cross.png"
                    alt="Close"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="Error"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}

export default McqResultCard;
